import React, { useEffect, useState } from 'react';
import { FaPen } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';

import { Skeleton } from '@material-ui/lab';

import Avatar from '~/components/Avatar';
import { useAuth } from '~/hooks/auth';
import { IState } from '~/store';
import { getUserProfileRequest } from '~/store/modules/users/actions';
import colors from '~/styles/colors';

import AddressItems from './AddressItems';
import EditProfileModal from './EditProfileModal';
import ProfileInfoSkelleton from './ProfileInfoSkelleton';
import {
  Container,
  UserCredentials,
  Box,
  AvatarBox,
  EditBox,
  UserInformation,
  Top,
  Bottom,
  EditIcon,
  UserName,
  UserRole,
  UserEmailContact,
} from './styles';
import UserInformationItems from './UserInformationItems';

const Profile = () => {
  const userProfile = useSelector((state: IState) => state.users.userProfile);
  const loadingGroupsOrProfile = useSelector(
    (state: IState) => state.users.loadingGroupsOrProfile,
  );

  const { user } = useAuth();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserProfileRequest(user.personId));
  }, [dispatch, user.personId]);

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <Container>
      <UserCredentials>
        <Box>
          <AvatarBox>
            {!loadingGroupsOrProfile && userProfile ? (
              <Avatar
                image={userProfile.thumbnail}
                variant="secondary"
                size={80}
              />
            ) : (
              <Skeleton
                animation="wave"
                variant="rect"
                style={{ borderRadius: '50%', height: '80px', width: '80px' }}
              />
            )}
          </AvatarBox>
          <EditBox>
            {!loadingGroupsOrProfile && userProfile ? (
              <EditIcon onClick={() => setModalOpen(true)}>
                <FaPen size={20} color={colors.primary} />
              </EditIcon>
            ) : (
              <Skeleton
                animation="wave"
                variant="rect"
                height={30}
                width="30%"
                style={{ borderRadius: '5px' }}
              />
            )}

            <EditProfileModal setOpenModal={setModalOpen} open={modalOpen} />
          </EditBox>
        </Box>

        {!loadingGroupsOrProfile && userProfile ? (
          <UserName>{`${userProfile?.firstName} ${userProfile?.lastName}`}</UserName>
        ) : (
          <Skeleton
            animation="wave"
            variant="rect"
            height={16}
            width="100%"
            style={{ margin: '26px' }}
          />
        )}

        {!loadingGroupsOrProfile && userProfile ? (
          <UserRole>{userProfile?.dynamicAttributes?.office}</UserRole>
        ) : (
          <Skeleton animation="wave" variant="rect" height={10} width="50%" />
        )}

        {!loadingGroupsOrProfile && userProfile ? (
          <UserEmailContact>
            {userProfile?.dynamicAttributes?.emailContact}
          </UserEmailContact>
        ) : (
          <Skeleton
            animation="wave"
            variant="rect"
            height={10}
            width="80%"
            style={{ marginTop: '8px' }}
          />
        )}

        {!loadingGroupsOrProfile && userProfile ? (
          <p>{user.orgName}</p>
        ) : (
          <Skeleton
            animation="wave"
            variant="rect"
            height={10}
            width="30%"
            style={{ marginTop: '8px' }}
          />
        )}
      </UserCredentials>
      <UserInformation>
        <Top>
          <h2>Informações gerais</h2>
          {!loadingGroupsOrProfile && userProfile ? (
            <UserInformationItems userProfile={userProfile} />
          ) : (
            <ProfileInfoSkelleton />
          )}
        </Top>
        <Bottom>
          <h2>Endereço</h2>
          {!loadingGroupsOrProfile && userProfile ? (
            <AddressItems userProfile={userProfile} />
          ) : (
            <ProfileInfoSkelleton />
          )}
        </Bottom>
      </UserInformation>
    </Container>
  );
};

export default Profile;
